import { usePrivateBetaWalletWhitelistCheck } from 'src/hooks/privateBetaWalletWhitelist/usePrivateBetaWalletWhitelistCheck';

export interface PrivateBetaWalletWhitelistStatus {
	hasAccess: boolean;
	isLoading: boolean;
	isPrivateBetaWhitelistEnabled: boolean;
}

export function usePrivateBetaWalletWhitelistStatus(): PrivateBetaWalletWhitelistStatus {
	const {
		isPrivateBetaWhitelistEnabled,
		isEmulatingAccount,
		connected,
		authority,
		isWhitelisted,
		isLoading,
		isError,
	} = usePrivateBetaWalletWhitelistCheck();

	if (!isPrivateBetaWhitelistEnabled || isEmulatingAccount) {
		return {
			hasAccess: true,
			isLoading: false,
			isPrivateBetaWhitelistEnabled: false,
		};
	}

	if (!connected || !authority) {
		return {
			hasAccess: true,
			isLoading: false,
			isPrivateBetaWhitelistEnabled: true,
		};
	}

	if (isLoading) {
		return {
			hasAccess: false,
			isLoading: true,
			isPrivateBetaWhitelistEnabled: true,
		};
	}

	return {
		hasAccess: isWhitelisted === true && !isError,
		isLoading: false,
		isPrivateBetaWhitelistEnabled: true,
	};
}
